import React from 'react';
import styled from 'styled-components';
import { useWindowSizeInRem } from '../../../platform/Hook';
import { Colors, toRem } from '../../../ui';
import { Logo } from '../../canvas/ui/Logo';
import { Flexer, Title } from './LayoutElements';

export type EmptyBlockProps = {
    grow?: boolean,
    minHeight?: number | string,
    title?: string,
    subtitle?: string,
    children?: React.ReactNode,
};

const Tail = () => {
    const style = {
        width: '2rem',
        position: 'absolute' as const,
        left: 0,
        top: '50%',
        transform: 'translateX(-100%) translateY(-25%)',
    };
    return <svg style={style} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23 0C23 7.97232 9.70447 14.8421 1.29324 17.9765C0.455896 18.2885 0.38798 19.4505 1.21366 19.7921C11.3724 23.996 19.3687 21.3011 22.6056 19.0683C22.8605 18.8925 23 18.5994 23 18.2898V0Z" fill="#E7EBF4" />
    </svg>;
};

const useDefaultMinHeight = () => {
    const ws = useWindowSizeInRem();
    if (ws.height > 75) return 40;
    if (ws.height > 65) return 32;
    if (ws.height > 55) return 24;
    return 16;
};

const Frame = styled.div<{ grow?: boolean, minHeight: number | string }>`
    //relative minHeight={minHeight ?? defaultMinHeight} grow flex="column" center gap="1" borderRadius="1" background={Colors.borderLight}
    position: relative;
    min-height: ${p => toRem(p.minHeight)};
    ${p => p.grow && 'flex: 1 1 auto;'}
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    border-radius: 1rem;
    background: #F5F7FE;
`;

export const EmptyBlock = ({ grow, minHeight, title, subtitle, children }: EmptyBlockProps) => {
    const defaultMinHeight = useDefaultMinHeight();
    return <Frame grow={grow} minHeight={minHeight ?? defaultMinHeight}>
        {(title || subtitle) &&
            <Flexer flex="row" align="center" gap="3" color={Colors.textMenu}>
                <Logo size="5" />
                <Flexer relative grow flex="column" gap=".75" padding="1.5" borderRadius="1" background="#E7EBF4">
                    <Tail />
                    {title && subtitle && <Title size="lg" weight={500} color={Colors.textMenu} flush>{title}</Title>}
                    {title && !subtitle && <Title size="md" weight={450} color={Colors.textMenu} flush>{title}</Title>}
                    {subtitle && <Title size="sm" weight={400} color={Colors.textMenu} flush>{subtitle}</Title>}
                </Flexer>
            </Flexer>
        }
        {children}
    </Frame>;
};
